export const QueryKey = 'goals'
export const Goals = '/api/v1/goals'
